function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoFill = function SvgVideoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M25.31 9.063a1.363 1.363 0 0 0-1.388 0l-3.155 2.284v-.882A3.47 3.47 0 0 0 17.3 7H5.465A3.466 3.466 0 0 0 2 10.465v7.832a3.466 3.466 0 0 0 3.465 3.465h11.832a3.466 3.466 0 0 0 3.465-3.465v-.882l3.156 2.284a1.386 1.386 0 0 0 2.082-1.2v-8.23a1.365 1.365 0 0 0-.69-1.206Z",
    fill: "#FF5C7F"
  }));
};
export default SvgVideoFill;